var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "1iozmall1a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.419608 0 0 0 0 0.356863 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-396 -622) translate(396 615)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.026 11.517c-2.088 0-3.786-1.62-3.786-3.613 0-1.991 1.698-3.612 3.786-3.612s3.786 1.62 3.786 3.612-1.698 3.613-3.786 3.613M12 0C7.037 0 3 3.863 3 8.61c0 2.757 1.454 6.163 4.32 10.125 2.116 2.922 4.258 5.08 4.277 5.1.104.105.251.165.403.165h.006c.153-.001.3-.064.405-.173.088-.093 2.198-2.317 4.27-5.223C19.547 14.587 21 11.224 21 8.61 21 3.863 16.963 0 12 0",
    transform: "translate(0 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDirections);
export default __webpack_public_path__ + "static/media/icons-directions.1f06000ad804739d865b1ae618049939.svg";
export { ForwardRef as ReactComponent };